import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    name: '',
    id: '',
    isEditable: false,
    isLoading: false,
    resetForm: false,
    showAddButtons: false
    // prevScreen: {
    //     courseIntro: 'courseCover',
    //     courseDetails: 'courseIntro',
    //     units: "courseDetails"
    // }
};
const unitSlice = createSlice({
    name: 'unitSlice',
    initialState,
    reducers: {
        setUnitScreenName: (state, { payload }) => {
            console.log('Payload fetched', payload);
            state.name = payload;
        },
        setUnitScreenId: (state, { payload }) => {
            state.id = payload;
        },
        setUnitScreenState: (state, { payload }) => {
            state.isEditable = payload;
        },
        setUnitScreenLoading: (state, { payload }) => {
            state.isLoading = payload;
        },
        resetUnitScreenForm: (state, { payload }) => {
            state.resetForm = payload;
        }
    }
});

export const {
    setUnitScreenName,
    setUnitScreenId,
    setUnitScreenState,
    setUnitScreenLoading,
    resetUnitScreenForm
} = unitSlice.actions;

export default unitSlice.reducer;
